import { createApp, defineAsyncComponent } from 'vue';
import store from 'shared/store';
import {
	initFormKitSchema,
	formKitSchemaOptions,
} from 'shared/utils/initFormKitSchema';
import RichTextCtaBanner from './RichTextCtaBanner.vue';
import './c-rich-text-cta-banner.scss';

async function mountRichTextCtaBanner() {
	const richTextCtaBanner = document.getElementById('rich-text-cta-banner');

	if (!richTextCtaBanner) {
		console.warn('[RichTextCtaBanner] Container not found');
		return;
	}

	const options = await formKitSchemaOptions();
	const app = createApp({
		name: 'RichTextCtaBannerApp',
	});
	app.component('rich-text-cta-banner', RichTextCtaBanner);
	app.component(
		'send-campaign-id-cta-button',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/SendCampaignIdCtaButton.vue'),
		),
	);
	app.component(
		'cta-button-with-popup-form',
		defineAsyncComponent(
			() =>
				import('shared/components/actionButtonWithCTA/CtaButtonWithPopupForm.vue'),
		),
	);
	app.component(
		'form-kit-builder-container',
		defineAsyncComponent(
			() =>
				import('shared/components/FormKitBuilderContainer/FormKitBuilderContainer.vue'),
		),
	);
	await initFormKitSchema(app, options);
	app.use(store);
	app.mount(richTextCtaBanner);
}

mountRichTextCtaBanner().catch((error) => {
	console.error('Error mounting RichTextCtaBanner:', error);
});
